// @ts-check
// @ts-ignore Vite replaces this compile-time constant.
export const BUILD_ID = __BUILD_ID__;
